export default "__VITE_ASSET__BMIl6MgM__"